<!--  -->
<template>
  <div class="cen">
    <ul class="create_ul">
      <li class="li3" @click="add">
        <img src="../assets/images/add.png" />
        <p>创建学生</p>
      </li>
      <div v-for="(item, index) of createList" :key="'li2' + index">
        <li
          class="li2"
          v-if="
            item.state != 0 &&
            item.state != 1 &&
            item.state != 2 &&
            (item.step == 1 ||
              item.step == 2 ||
              item.step == 3 ||
              item.step == 4 ||
              item.step == 5)
          "
        >
          <img
            class="span2"
            @click="deletelists(item.id)"
            v-show="item.state !== 3"
            src="../assets/images/del.png"
          />
          <p
            @click="
              tiao(
                item.step,
                item.id,
                item.studentIdCard,
                item.enrollmentGrade,
                item.mold
              )
            "
          >
            <span style="color: #0f9386; display: inline; font-size: 0.72rem">{{
              item.studentName
            }}</span
            >信息待提交
          </p>
          <span
            @click="
              tiao(
                item.step,
                item.id,
                item.studentIdCard,
                item.enrollmentGrade,
                item.mold,
                item.propertyType,
                item.propertyRelationship,
                item.sameActual
              )
            "
            >继续完善信息</span
          >
        </li>
      </div>
      <div v-for="(item, index) of createList" :key="index">
        <li class="li1" v-if="item.state != 3">
          <p
            @click="
              examine(
                item.studentName,
                item.id,
                item.state,
                item.enrollmentGrade,
                item.studentIdCard
              )
            "
          >
            学生姓名：{{ item.studentName }}
            <span v-if="item.state == 0" style="color: orange"
              >（正在审核）</span
            >
            <span v-if="item.state == 1" style="color: green"
              >（审核已经完成）</span
            >
            <span v-else-if="item.state == 2" style="color: red"
              >（未通过）</span
            >
          </p>
          <p
            @click="
              examine(
                item.studentName,
                item.id,
                item.state,
                item.enrollmentGrade,
                item.studentIdCard
              )
            "
          >
            身份证号：{{ item.studentIdCard }}
          </p>
          <p>报名学校：{{ item.schoolName }}</p>
          <p v-if="item.state == 1">录取学校：{{ item.admittedSchools }}</p>
          <img
            src="../assets/images/into.png"
            alt=""
            @click="
              examine(
                item.studentName,
                item.id,
                item.state,
                item.enrollmentGrade,
                item.studentIdCard
              )
            "
          />
        </li>
      </div>
    </ul>
    <notices></notices>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import "element-ui/lib/theme-chalk/index.css";
import { show, deluser } from "@/api/news";
import sessionUtils from "@/utils/session-store-utils";
import notices from "../components/notices.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { notices },
  data() {
    //这里存放数据
    return {
      show: false,
      show1: false,
      delid: "", //删除id
      createList: [],
      createUser: [],
      loginUserId: "",
      loading: false,
      codeDisabled: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //0 待审核 1审核通过 2未通过 3继续完善
  created() {
    sessionStorage.removeItem("from1");
    sessionStorage.removeItem("from2");
    sessionStorage.removeItem("from3");
    sessionStorage.removeItem("from4");
    sessionStorage.removeItem("oneid");
    sessionStorage.removeItem("twoid");
    sessionStorage.removeItem("threeid");
    sessionStorage.removeItem("fourid");
    sessionStorage.removeItem("fcimgstaus");
    sessionStorage.removeItem("imgstaus");
    this.createUser = sessionUtils.getUser();
    const item = this.createUser;
    this.loginUserId = item.id;
    console.log("loginUserId===>", this.loginUserId);
    this.loadBaseData();
  },
  methods: {
    //用户须知公共弹窗
    tan() {
      this.$notice(true);
    },
    //获取首页学生列表数据
    async loadBaseData() {
      // this.$refs.page.showLoading()
      this.$toast.loading();
      const res = await show({ id: this.loginUserId });
      console.log(res);
      this.$toast.clear();
      if (res.code == "200") {
        this.createList = res.data.reverse();
        // this.createList.reverse();
        this.loading = false;
      }
      // this.$refs.page.hideLoading()
    },
    //删除学生信息
    async deluser() {
      this.codeDisabled = true;
      this.$toast.loading();
      const res = await deluser({ userInfoId: this.delid });
      console.log(res);
      this.codeDisabled = false;
      this.show1 = false;
      this.loading = false;
      if (res.code == "200") {
        this.$toast("删除成功");
        this.loadBaseData();
      } else {
        this.$toast("删除失败", res.msg);
      }
    },
    deletelists(id) {
      this.delid = id;
      this.show1 = true;
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "确定要删除该条学生信息吗?",
        })
        .then(() => {
          // on confirm
          this.deluser();
        })
        .catch(() => {
          // on cancel
        });
    },
    add() {
      if (this.createList.length > 0) {
        let isHaveChild = false;
        for (let i = 0; i < this.createList.length; i++) {
          if (this.createList[i].state == 3) {
            isHaveChild = true;
            break;
          }
        }
        if (isHaveChild) {
          // alert(
          //   "温馨提示：\n\n1、为防止您的数据重复,如有未完成或未通过的学生信息,不要重新创建\n\n2、请在原信息基础上继续完善 "
          // );
          this.$dialog
            .alert({
              title: "温馨提示",
              message:
                "1、为防止您的数据重复，如有未完成或未通过的学生信息，不要重新创建\n2、请在原信息基础上继续完善",
            })
            .then(() => {
              // on close
            });
          this.show = true;
        } else {
          this.$router.push("choose");
        }
      } else {
        this.$router.push("choose");
      }
    },

    toDetails(name, id, state) {
      this.$compareUpAndDown.setResult(null, null, null);
      this.$router.push({
        name: ["examine", "failed", "past"][state - 1],
        query: { id: id, name: name },
      });
    },
    //继续完善信息
    tiao(step, id, idno, xueduan) {
      console.log(step, id);
      sessionStorage.setItem("userInfoId", JSON.stringify(id));
      sessionStorage.setItem("idno", JSON.stringify(idno));
      sessionStorage.setItem("xueduan", JSON.stringify(xueduan));
      if (step == 1) {
        this.$router.push({
          path: "/p-register",
          // query: { backId: id },
        });
      } else if (step == 2) {
        this.$router.push({
          path: "/p-r-upload",
          // query: { backId: id },
        });
      } else if (step == 3) {
        this.$router.push({
          path: "/property",
          // query: { backId: id },
        });
      } else if (step == 4) {
        this.$router.push({
          path: "/school",
          // query: { backId: id },
        });
      }
    },
    //查看审核情况
    examine(name, id, state, xueduan, idno) {
      sessionStorage.setItem("userInfoId", JSON.stringify(id));
      sessionStorage.removeItem("from1");
      sessionStorage.removeItem("from2");
      sessionStorage.removeItem("from3");
      sessionStorage.removeItem("from4");
      sessionStorage.removeItem("oneid");
      sessionStorage.removeItem("twoid");
      sessionStorage.removeItem("threeid");
      sessionStorage.removeItem("fourid");
      sessionStorage.removeItem("fcimgstaus");
      sessionStorage.removeItem("imgstaus");
      sessionStorage.setItem("xueduan", JSON.stringify(xueduan));
      sessionStorage.setItem("idno", JSON.stringify(idno));
      this.$router.push({
        name: "examine",
        query: { name: name, state: state }, //0 待审核 1审核通过 2未通过 3继续完善
      });
    },
    toContinue(
      step,
      id,
      reason,
      sameProperty,
      mold,
      propertyType,
      propertyRelationship,
      sameActual
    ) {
      this.$compareUpAndDown.setResult(null, null, null);
      if (mold === 1) {
        if (step === 1) {
          this.$router.push({
            path: "/register",
            query: { backId: id },
          });
        } else if (step === 2) {
          if (reason === "" || reason === undefined) {
            this.$router.push({
              path: "/r-upload",
              query: { backId: id },
            });
          } else if (reason === "离婚") {
            this.$router.push({
              path: "/r-upload1",
              query: { backId: id, reason: reason },
            });
          } else {
            this.$router.push({
              path: "/r-upload2",
              query: { backId: id, reason: reason },
            });
          }
        } else if (step === 3) {
          this.$router.push({
            path: "/house",
            query: { backId: id },
          });
        } else if (step === 4) {
          if (sameActual == 1) {
            if (sameProperty == 1) {
              this.$router.push({
                path: "/h-upload",
                query: { backId: id },
              });
            } else if (sameProperty == 2) {
              this.$router.push({
                path: "/h-upload",
                query: { backId: id },
              });
            }
          } else if (sameActual == 2) {
            if (sameProperty == 1) {
              this.$router.push({
                path: "/h-upload",
                query: { backId: id, propertyType: propertyType },
              });
            } else if (sameProperty == 2) {
              this.$router.push({
                path: "/h-upload",
                query: { backId: id, propertyType: propertyType },
              });
            }
          }
        } else if (step === 5) {
          this.$router.push({
            path: "/school",
            query: { backId: id, sign: 1 },
          });
        } else if (step === 6) {
          this.$router.push({
            path: "/submit",
            query: { backId: id, sign: 2 },
          });
        }
      } else if (mold === 2) {
        if (step === 1) {
          this.$router.push({
            path: "/p-register",
            query: { backId: id },
          });
        } else if (step === 2) {
          this.$router.push({
            path: "/p-r-upload",
            query: { backId: id },
          });
        } else if (step === 3) {
          this.$router.push({
            path: "/property",
            query: { backId: id },
          });
        } else if (step === 4) {
          this.$router.push({
            path: "/p-upload",
            query: { backId: id },
          });
        } else if (step === 5) {
          this.$router.push({
            path: "/school",
            query: { backId: id, sign: 2 },
          });
        } else if (step === 6) {
          this.$router.push({
            path: "/submit",
            query: { backId: id },
          });
        }
      } else if (mold === 3) {
        if (step === 0) {
          this.$router.push({
            path: "/s-upload",
            query: { backId: id },
          });
        } else if (step === 1) {
          this.$router.push({
            path: "/s-register",
            query: { backId: id },
          });
        } else if (step === 2) {
          this.$router.push({
            path: "/s-upload1",
            query: { backId: id },
          });
        } else if (step === 5) {
          this.$router.push({
            path: "/s-school",
            query: { backId: id },
          });
        } else if (step === 6) {
          this.$router.push({
            path: "/submit",
            query: { backId: id, sign: 1 },
          });
        }
      }
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.cen {
  min-height: calc(100vh - 2rem);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0rem;
}
.create_ul {
  width: 90%;
  height: auto;
  margin: 0;
  margin-bottom: 1rem;
}
.create_ul li {
  width: 100%;
  height: 6rem;
  background: #f9f9f9;
  border: 0.04rem solid #979797;
  border-radius: 0.2rem;
  float: left;
  margin-top: 1rem;
}
.create_ul .li1 {
  font-family: PingFangSC-Regular;
  font-size: 0.64rem;
  color: #323232;
  letter-spacing: 0.03rem;
  text-indent: 2em;
  /*line-height:2rem;*/
  line-height: 1.2rem;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
}
.create_ul .li1 img {
  position: absolute;
  top: 60%;
  margin-top: -0.84rem;
  right: 4%;
  width: 1rem;
}
.create_ul .li1 p {
  margin-block-start: 0em;
  margin-block-end: 0em;
}
.create_ul .li1 p span {
  color: #00001b;
}
.create_ul .li1 .span1 {
  position: absolute;
  top: 17%;
}
.span2 {
  position: relative;
  cursor: pointer;
  top: 5%;
  left: 42%;
  width: 1rem;
}
.create_ul .li2 p {
  font-family: PingFangSC-Regular;
  font-size: 0.72rem;
  color: #323232;
  letter-spacing: 0.04rem;
  text-align: center;
  margin-top: 0.8rem;
  margin-block-start: 0em;
  margin-block-end: 0em;
}
.create_ul .li2 span {
  display: block;
  width: 5rem;
  margin: 1.2rem auto;
  font-family: PingFangSC-Regular;
  font-size: 0.8rem;
  line-height: 0.88rem;
  color: #0f9386;
  letter-spacing: 0.03rem;
  cursor: pointer;
}
.create_ul .li2 span:hover {
  border-bottom: 0.04rem solid #0f9386;
}
.create_ul .li3 {
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.create_ul .li3 img {
  //   position: absolute;
  //   top: 0.8rem;
  //   left: 51%;
  //   margin-left: -1.5rem;
  width: 2.5rem;
}
.create_ul .li3 p {
  font-family: PingFangSC-Regular;
  font-size: 0.72rem;
  color: #323232;
  letter-spacing: 0.04rem;
  text-align: center;
  //   margin-top: 4.2rem;
}
</style>